import { Issues } from "valibot";

import classNames from "./utils/classNames";

export const setLocalStorageValue = (key: string, value: string) => {
  try {
    localStorage[key] = value;
  } catch {
    // Do nothing
  }
};

export const getLocalStorageValue = (key: string) => {
  try {
    return localStorage[key];
  } catch {
    // Do nothing
  }
  return "";
};

export const setSessionStorageValue = (key: string, value: string) => {
  try {
    sessionStorage[key] = value;
  } catch {
    // Do nothing
  }
};

export const getSessionStorageValue = (key: string) => {
  try {
    return sessionStorage[key];
  } catch {
    // Do nothing
  }
  return "";
};

export const copy = (value: any) => JSON.parse(JSON.stringify(value));

// Updated in getAppSettings()
export const debugLogSettings = {
  useConsole: false,
};

export const debugLog = (...args: unknown[]) => {
  if (debugLogSettings.useConsole) {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = () => {};

export const sleep = (ms: number) =>
  new Promise<void>(resolve => setTimeout(() => resolve(), ms));

export const logParsedIssues = (issues: Issues) => {
  for (const issue of issues) {
    const path = issue.path?.map(pathItem => pathItem.key).join(".");
    // eslint-disable-next-line no-console
    console.error(
      `${path}: expected ${issue.validation}, received ${issue.input}`,
    );
  }
};

export const safeParseJSON = (value: unknown) => {
  try {
    return JSON.parse(String(value));
  } catch {
    //
  }
};

export const getStorageKey = (
  instanceName: string,
  botInfoId: string,
  key: string,
) => `${instanceName}_${key}_${botInfoId}`;

export const getUserDataStorageKey = (
  instanceName: string,
  botInfoId: string,
) => getStorageKey(instanceName, botInfoId, "botsonicUser");

export const getUserFormStorageKey = (
  instanceName: string,
  botInfoId: string,
) => getStorageKey(instanceName, botInfoId, "botsonicForm");

export const generateUuid = () => {
  let d = Date.now(),
    d2 =
      (typeof performance !== "undefined" &&
        performance.now &&
        performance.now() * 1_000) ||
      0;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replaceAll(/[xy]/g, c => {
    let r = Math.random() * 16;
    if (d > 0) {
      r = Math.trunc((d + r) % 16);
      d = Math.floor(d / 16);
    } else {
      r = Math.trunc((d2 + r) % 16);
      d2 = Math.floor(d2 / 16);
    }
    // eslint-disable-next-line eqeqeq
    return (c == "x" ? r : (r & 0x7) | 0x8).toString(16);
  });
};

export const getMessageClassName = (isSent: boolean) =>
  classNames(
    "max-w-full break-words rounded-xl px-3",
    isSent
      ? "!mb-1 border border-solid border-[var(--borderColor)] bg-[var(--whiteOrChatBotColor)] py-1.5 text-[var(--invertedColor)]"
      : "bg-surface py-2.5 text-dark",
  );
